/**
 * Check if current time is within smart menu working hours.
 * Returns true if no schedule is configured (backward compat).
 *
 * @param {Array|null} schedule - Array indexed by day_code (0=Sunday..6=Saturday)
 * @returns {boolean}
 */
export function isWithinSmartMenuWorkingHours(schedule) {
    if (!schedule || typeof schedule !== 'object') return true;

    const now = new Date();
    const dayCode = now.getDay(); // 0=Sunday
    const currentHour = now.getHours();

    const todaySchedule = schedule[dayCode];
    if (!todaySchedule) return true;
    if (!todaySchedule.is_active) return false;

    return currentHour >= todaySchedule.opens_at && currentHour < todaySchedule.closes_at;
}
